import { ChartDataMode, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { IOTS_UPTIME_CHART_ENDPOINT } from '../iot-chart-endpoints';

export const IOTS_UPTIME_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.IOTS_UPTIME_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: IOTS_UPTIME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.DATA_MODE, value: ChartDataMode.PERCENTAGE }]
};
